import { handleErrors } from './ErrorActions';
import * as attachmentsApi from '../api/attachments';

export const SET_ATTACHMENT_TEXT_PENDING = 'SET_ATTACHMENT_TEXT_PENDING';
export const UPLOAD_ATTACHMENT_TEXT_SUCCESS = 'UPLOAD_ATTACHMENT_TEXT_SUCCESS';

export const getAttachmentText = ({ attachmentId }) => {
  return async (dispatch) => {
    try {
      if (!attachmentId) {
        throw new Error('Attachment Id is not found');
      }

      dispatch({
        type: SET_ATTACHMENT_TEXT_PENDING,
        payload: true,
      });

      const apiData = await attachmentsApi.getAttachmentText(attachmentId);

      if (apiData.hasError) {
        dispatch({
          type: SET_ATTACHMENT_TEXT_PENDING,
          payload: false,
        });

        dispatch(handleErrors(apiData.errors, { isTopBanner: true }));
        return;
      }

      dispatch({
        type: UPLOAD_ATTACHMENT_TEXT_SUCCESS,
        payload: {
          attachmentId,
          text: apiData.resource?.text,
        },
      });
    } catch (error) {
      dispatch(handleErrors(error, { isTopBanner: true }));
    }
  };
};
